import {Component, Input} from '@angular/core';
import {Game} from "../../../models/game.class";
import {GameService} from "../../../services/game.service";

@Component({
  selector: 'app-like-label',
  templateUrl: './like-label.component.html',
  styleUrls: ['./like-label.component.scss']
})
export class LikeLabelComponent {
  @Input() game!: Game;
  @Input() favouriteGameIds!: number[];

  constructor(
    private gameService: GameService
  ) {  }


  setFavourites(gameId: number){
    this.gameService.updateFavouriteGames(gameId.toString())
  }

}
